import React from "react";
import { CCard, CCardBody, CProgress, CSpinner } from "@coreui/react";

// "Number of User" BRD — users with incomplete profile information,
// broken down by which profile field is missing.
const IncompleteProfilesCard = ({ data, loading, error }) => {
  const formatNumber = (num) => {
    if (num >= 1e9) return (num / 1e9).toFixed(2) + "B";
    if (num >= 1e6) return (num / 1e6).toFixed(2) + "M";
    if (num >= 1e3) return (num / 1e3).toFixed(2) + "K";
    return num;
  };

  const totalUsers = data?.totalUsers || 0;
  const totalIncomplete = data?.totalIncomplete || 0;
  const breakdown = data?.breakdown || [];
  const incompletePct =
    totalUsers > 0 ? ((totalIncomplete / totalUsers) * 100).toFixed(1) : 0;

  return (
    <CCard className="border-light">
      <CCardBody>
        <h5 style={{ marginBottom: "2px" }}>Incomplete Profiles</h5>
        <span className="text-muted" style={{ fontSize: "0.85em" }}>
          Registered users missing profile information, by missing field
        </span>
        {loading ? (
          <div className="d-flex justify-content-center py-4">
            <CSpinner color="primary" />
          </div>
        ) : error ? (
          <div className="text-danger py-3">{error}</div>
        ) : (
          <>
            <div className="mt-3">
              <h3>
                <strong>{formatNumber(totalIncomplete)}</strong>
                <span
                  style={{
                    marginLeft: "10px",
                    color: "#6c757d",
                    fontSize: "0.6em",
                  }}
                >
                  of {formatNumber(totalUsers)} users ({incompletePct}%)
                </span>
              </h3>
              <span className="text-muted">
                Users With an Incomplete Profile
              </span>
            </div>
            <div className="mt-3">
              {breakdown.map((item) => {
                const pct =
                  totalUsers > 0 ? (item.missing / totalUsers) * 100 : 0;
                return (
                  <div key={item.field} style={{ marginBottom: "12px" }}>
                    <div className="d-flex justify-content-between">
                      <span style={{ fontSize: "0.9em" }}>
                        Missing {item.label}
                      </span>
                      <span style={{ fontSize: "0.9em" }}>
                        <strong>{formatNumber(item.missing)}</strong>{" "}
                        <span className="text-muted">({pct.toFixed(1)}%)</span>
                      </span>
                    </div>
                    <CProgress
                      thin
                      color="danger"
                      value={pct}
                      style={{ marginTop: "4px" }}
                    />
                  </div>
                );
              })}
            </div>
          </>
        )}
      </CCardBody>
    </CCard>
  );
};

export default IncompleteProfilesCard;
